import { UserPhoneResponse, SettingsRequest, UserActionRequest, UserRequest, UserState, UserDeleteAccountRequest } from "./contracts/state";
import {
    DeleteUserAccountActionInterface,
    FetchPinTweetActionInterface,
    FetchReadMessagesActionInterface,
    FetchSignInActionInterface,
    FetchSignUpActionInterface,
    FetchUserDataActionInterface,
    FetchUserVeracityScoreInterface,
    FollowUserActionInterface,
    ProcessFollowRequestActionInterface,
    ProcessUserToBlocklistActionInterface,
    ProcessUserToMuteListActionInterface,
    ResetMentionsActionInterface,
    ResetNotificationsActionInterface,
    SetAddBlockedUserActionInterface,
    SetBackgroundColorActionInterface,
    SetBlockedUserDataActionInterface,
    SetColorSchemeActionInterface,
    SetCountryActionInterface,
    SetDeleteUserAccountActionInterface,
    SetDirectActionInterface,
    SetEmailActionInterface,
    SetFollowersSizeActionInterface,
    SetGenderActionInterface,
    SetLanguageActionInterface,
    SetNewMentionActionInterface,
    SetNewNotificationActionInterface,
    SetPhoneActionInterface,
    SetPhotoTaggingActionInterface,
    SetPinTweetIdActionInterface,
    SetPrivateProfileActionInterface,
    SetProfileStartedActionInterface,
    SetReadMessageActionInterface,
    SetTokenLoadingStateActionInterface,
    SetUnreadMessageActionInterface,
    SetUserDataActionInterface,
    SetUserErrorMsgActionInterface,
    SetUserFollowerActionInterface,
    SetUserFollowingActionInterface,
    SetUserLoadingStateActionInterface,
    SetUsernameActionInterface,
    SetVeracityScoreInterface,
    SignOutActionInterface,
    StartUseTwitterActionInterface,
    UnfollowUserActionInterface,
    UpdateBackgroundColorActionInterface,
    UpdateColorSchemeActionInterface,
    UpdateCountryActionInterface,
    UpdateDirectActionInterface,
    UpdateEmailActionInterface,
    UpdateGenderActionInterface,
    UpdateLanguageActionInterface,
    UpdatePhoneActionInterface,
    UpdatePhotoTaggingActionInterface,
    UpdatePrivateProfileActionInterface,
    UpdateUserDataActionInterface,
    UpdateUserVeracityScoreInterface,
    UpdateUsernameActionInterface,
    UserActionsType
} from "./contracts/actionTypes";
import { EndRegistrationRequest } from "../../../pages/Authentication/SetPasswordModal/SetPasswordModal";
import { ChatMessageResponse } from "../../../types/chat";
import { LoginRequest } from "../../../types/auth";
import { VeracityScoreRequest } from '../../../pages/Authentication/VeracityModal/VeracityModal';

export const updatedUserData = (payload: UserRequest): UpdateUserDataActionInterface => ({
    type: UserActionsType.UPDATE_USER_DATA,
    payload
});

export const setFollowersSize = (): SetFollowersSizeActionInterface => ({
    type: UserActionsType.SET_FOLLOWERS_SIZE
});

export const setProfileStarted = (payload: boolean): SetProfileStartedActionInterface => ({
    type: UserActionsType.SET_PROFILE_STARTED,
    payload
});

export const setPinTweetId = (payload: string): SetPinTweetIdActionInterface => ({
    type: UserActionsType.SET_PIN_TWEET_ID,
    payload
});

export const setReadMessage = (payload: number): SetReadMessageActionInterface => ({
    type: UserActionsType.SET_READ_MESSAGE,
    payload
});

export const setUserData = (payload: UserState["data"]): SetUserDataActionInterface => ({
    type: UserActionsType.SET_USER_DATA,
    payload
});

export const setBlockedUserData = (payload: UserState["blockedUsers"]): SetBlockedUserDataActionInterface => ({
    type: UserActionsType.SET_BLOCKED_USER_DATA,
    payload
})

export const setAddBlockedUser = (payload: string): SetAddBlockedUserActionInterface => ({
    type: UserActionsType.ADD_BLOCKED_USER,
    payload
})

export const signOut = (): SignOutActionInterface => ({
    type: UserActionsType.SIGN_OUT
});

export const fetchSignIn = (payload: LoginRequest): FetchSignInActionInterface => ({
    type: UserActionsType.FETCH_SIGN_IN,
    payload
});

export const fetchSignUp = (payload: EndRegistrationRequest): FetchSignUpActionInterface => ({
    type: UserActionsType.FETCH_SIGN_UP,
    payload
});

export const fetchVeracityScore = (payload: VeracityScoreRequest): FetchUserVeracityScoreInterface => ({
    type: UserActionsType.FETCH_VERACITY_SCORE,
    payload
})

export const updateVeracityScore = (payload: number): UpdateUserVeracityScoreInterface => ({
    type: UserActionsType.UPDATE_VERACITY_SCORE,
    payload
})

export const setVeracityScore = (payload: number): SetVeracityScoreInterface => ({
    type: UserActionsType.SET_VERACITY_SCORE,
    payload
})

export const fetchUserData = (): FetchUserDataActionInterface => ({
    type: UserActionsType.FETCH_USER_DATA
});

export const setUserLoadingStatus = (payload: UserState["status"]): SetUserLoadingStateActionInterface => ({
    type: UserActionsType.SET_USER_LOADING_STATE,
    payload
});

export const followUser = (payload: UserActionRequest): FollowUserActionInterface => ({
    type: UserActionsType.FOLLOW_USER,
    payload
});

export const unfollowUser = (payload: UserActionRequest): UnfollowUserActionInterface => ({
    type: UserActionsType.UNFOLLOW_USER,
    payload
});

export const setUserFollowing = (payload: boolean): SetUserFollowingActionInterface => ({
    type: UserActionsType.SET_USER_FOLLOWING,
    payload
});

export const setUserFollowers = (payload: boolean): SetUserFollowerActionInterface => ({
    type: UserActionsType.SET_USER_FOLLOWERS,
    payload
})

export const fetchPinTweet = (payload: string): FetchPinTweetActionInterface => ({
    type: UserActionsType.FETCH_PIN_TWEET,
    payload
});

export const processFollowRequest = (payload: string): ProcessFollowRequestActionInterface => ({
    type: UserActionsType.PROCESS_FOLLOW_REQUEST,
    payload
});

export const processUserToBlocklist = (payload: UserActionRequest): ProcessUserToBlocklistActionInterface => ({
    type: UserActionsType.PROCESS_USER_TO_BLOCKLIST,
    payload
});

export const processUserToMuteList = (payload: UserActionRequest): ProcessUserToMuteListActionInterface => ({
    type: UserActionsType.PROCESS_USER_TO_MUTELIST,
    payload
});

export const startUseTwitter = (): StartUseTwitterActionInterface => ({
    type: UserActionsType.START_USE_TWITTER,
});

export const fetchReadMessages = (payload: string): FetchReadMessagesActionInterface => ({
    type: UserActionsType.FETCH_READ_MESSAGES,
    payload
});

export const setUnreadMessage = (payload: ChatMessageResponse): SetUnreadMessageActionInterface => ({
    type: UserActionsType.SET_UNREAD_MESSAGE,
    payload
});

export const setNewNotification = (): SetNewNotificationActionInterface => ({
    type: UserActionsType.SET_NEW_NOTIFICATION
});

export const resetNotifications = (): ResetNotificationsActionInterface => ({
    type: UserActionsType.RESET_NOTIFICATIONS
});

export const setNewMention = (): SetNewMentionActionInterface => ({
    type: UserActionsType.SET_NEW_MENTION
});

export const resetMentions = (): ResetMentionsActionInterface => ({
    type: UserActionsType.RESET_MENTIONS
});

export const updateUsername = (payload: SettingsRequest): UpdateUsernameActionInterface => ({
    type: UserActionsType.UPDATE_USERNAME,
    payload
});

export const updateEmail = (payload: SettingsRequest): UpdateEmailActionInterface => ({
    type: UserActionsType.UPDATE_EMAIL,
    payload
});

export const updatePhone = (payload: SettingsRequest): UpdatePhoneActionInterface => ({
    type: UserActionsType.UPDATE_PHONE,
    payload
});

export const updateCountry = (payload: SettingsRequest): UpdateCountryActionInterface => ({
    type: UserActionsType.UPDATE_COUNTRY,
    payload
});

export const updateGender = (payload: SettingsRequest): UpdateGenderActionInterface => ({
    type: UserActionsType.UPDATE_GENDER,
    payload
});

export const updateLanguage = (payload: SettingsRequest): UpdateLanguageActionInterface => ({
    type: UserActionsType.UPDATE_LANGUAGE,
    payload
});

export const updateDirect = (payload: SettingsRequest): UpdateDirectActionInterface => ({
    type: UserActionsType.UPDATE_DIRECT,
    payload
});

export const updatePrivateProfile = (payload: SettingsRequest): UpdatePrivateProfileActionInterface => ({
    type: UserActionsType.UPDATE_PRIVATE_PROFILE,
    payload
});

export const updateColorScheme = (payload: SettingsRequest): UpdateColorSchemeActionInterface => ({
    type: UserActionsType.UPDATE_COLOR_SCHEME,
    payload
});

export const updateBackgroundColor = (payload: SettingsRequest): UpdateBackgroundColorActionInterface => ({
    type: UserActionsType.UPDATE_BACKGROUND_COLOR,
    payload
});

export const setUsername = (payload: string): SetUsernameActionInterface => ({
    type: UserActionsType.SET_USERNAME,
    payload
});

export const setEmail = (payload: string): SetEmailActionInterface => ({
    type: UserActionsType.SET_EMAIL,
    payload
});

export const setPhone = (payload: UserPhoneResponse): SetPhoneActionInterface => ({
    type: UserActionsType.SET_PHONE,
    payload
});

export const setCountry = (payload: string): SetCountryActionInterface => ({
    type: UserActionsType.SET_COUNTRY,
    payload
});

export const setGender = (payload: string): SetGenderActionInterface => ({
    type: UserActionsType.SET_GENDER,
    payload
});

export const setLanguage = (payload: string): SetLanguageActionInterface => ({
    type: UserActionsType.SET_LANGUAGE,
    payload
});

export const setDirect = (payload: boolean): SetDirectActionInterface => ({
    type: UserActionsType.SET_DIRECT,
    payload
});

export const setPrivateProfile = (payload: boolean): SetPrivateProfileActionInterface => ({
    type: UserActionsType.SET_PRIVATE_PROFILE,
    payload
});

export const setColorScheme = (payload: string): SetColorSchemeActionInterface => ({
    type: UserActionsType.SET_COLOR_SCHEME,
    payload
});

export const setBackgroundColor = (payload: string): SetBackgroundColorActionInterface => ({
    type: UserActionsType.SET_BACKGROUND_COLOR,
    payload
});

export const setTokenLoadingStatus = (payload: UserState["tokenStatus"]): SetTokenLoadingStateActionInterface => ({
  type: UserActionsType.SET_TOKEN_LOADING_STATE,
  payload
});

export const updatePhotoTagging = (payload: SettingsRequest): UpdatePhotoTaggingActionInterface => ({
  type: UserActionsType.UPDATE_PHOTO_TAGGING,
  payload
});

export const setPhotoTagging = (payload: SettingsRequest): SetPhotoTaggingActionInterface => ({
  type: UserActionsType.SET_PHOTO_TAGGING,
  payload
});

export const deleteAccount = (payload: UserDeleteAccountRequest): DeleteUserAccountActionInterface => ({
    type: UserActionsType.DELETE_ACCOUNT,
    payload
});

export const SetAccountDelete = (payload: boolean): SetDeleteUserAccountActionInterface => ({
    type: UserActionsType.SET_DELETE_ACCOUNT,
    payload
});

export const setUserErrorMsg = (payload: string): SetUserErrorMsgActionInterface => ({
    type: UserActionsType.SET_ERROR_MESSAGE,
    payload
});